import React, {useContext, useEffect} from 'react';
import {ThemeContext} from "./context/theme-context";
import {ThemeContextType} from "./types/theme";
import {DARK_THEME, LIGHT_THEME} from "./constants/themeConstants";
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import MoonIcon from './assets/icons/moon.svg';
import SunIcon from './assets/icons/sun.svg';
import BaseLayout from "./layout/base-layout";
import Dashboard from "./screens/dashboard/dashboard";
import PageNotFound from "./screens/error/page-not-found";
import './App.scss'


function App() {
  const {toggleTheme, theme} = useContext(ThemeContext) as ThemeContextType;
  console.log(theme)

  useEffect(() => {
    theme === DARK_THEME ? document.body.classList.add("dark-mode") : document.body.classList.remove("dark-mode")
  }, [theme]);

  return (
    <Router>
      <Routes>
        <Route element={<BaseLayout />}>
          <Route path="/" element={<Dashboard />} />
          <Route path="*" element={<PageNotFound />} />
        </Route>
      </Routes>
      <button type="button" className="theme-toggle-btn" onClick={toggleTheme}>
        <img className="theme-icon" src={theme === LIGHT_THEME ? SunIcon : MoonIcon} />
      </button>
    </Router>
  );
}

export default App;
